import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { Stage } from "../../util/Types";
export function getBrowserFirebaseDatabase(stage) {
    const firebaseConfig = stage === Stage.Prod ? {
        apiKey: "AIzaSyCUo1ktFBEKn_-TIblFKVHF_KGJRZ1FJ6Q",
        authDomain: "contact-3d.firebaseapp.com",
        projectId: "contact-3d",
        storageBucket: "contact-3d.appspot.com",
        messagingSenderId: "509482117872",
        appId: "1:509482117872:web:7129966f6c80761bea7035",
        measurementId: "G-BGYBLWGT66"
    } : {
        apiKey: "AIzaSyDx5ocjIy1_5eSgFZvW5wlEdSo8BgjOIzY",
        authDomain: "contact-3d-staging.firebaseapp.com",
        projectId: "contact-3d-staging",
        storageBucket: "contact-3d-staging.appspot.com",
        messagingSenderId: "90633421116",
        appId: "1:90633421116:web:356f4def288b4aaf6c5e39",
        measurementId: "G-4RGCV9SLRE"
    };
    const app = initializeApp(firebaseConfig);
    const database = getDatabase(app);
    const analytics = getAnalytics(app);
    return {
        database,
        app
    };
}
//# sourceMappingURL=BrowserFirebase.js.map